import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { ScrollReveal } from "@components/motion/Transitioned"
import { cn } from "@utils/tw"
import { defineBlock } from "eddev/blocks"
import { useEffect, useRef, useState } from "react"

export const meta: BlockMeta = {
  title: "Gallery",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/gallery", (props) => {
  const rootRef = useRef<HTMLDivElement>(null)
  const lastIndex = useRef(0)
  const [current, setCurrent] = useState(0)
  const images = props.images || []

  useEffect(() => {
    if (rootRef.current && current !== lastIndex.current) {
      const currentThumb = rootRef.current.querySelector(`.gallery-thumb-${current}`)
      if (currentThumb) {
        // currentThumb.scrollIntoView({ behavior: "smooth" })
      }
      lastIndex.current = current
    }
  }, [current, images.length, rootRef.current])

  return (
    <ScrollReveal>
      <div ref={rootRef} className="w-full my-10 bg-black py-7 overflow-hidden select-none" data-transition="fade">
        <div className="w-grid mx-auto flex flex-col gap-5">
          <div className="w-full aspect-video md:aspect-[16/8] relative bg-black" data-transition="scale">
            {images.map(
              (image, index) =>
                !!image?.mediaItemUrl && (
                  <ResponsiveImage
                    key={index}
                    {...image}
                    alt={`Gallery image ${index + 1}`}
                    className={cn(
                      "absolute left-0 top-0 w-full h-full object-cover transition-opacity duration-300 pointer-events-none rounded-xl overflow-hidden",
                      current === index ? "opacity-100" : "opacity-0",
                    )}
                    objectFit="cover"
                  />
                ),
            )}
            <div
              className="size-galleryButton absolute top-1/2 -left-5 md:left-4 -translate-y-1/2 cursor-pointer group"
              onClick={() => setCurrent((current - 1 + images.length) % images.length)}
            >
              <svg className="w-full h-full" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="36"
                  y="35"
                  width="35"
                  height="34"
                  rx="17"
                  transform="rotate(-180 36 35)"
                  fill="#E5E8DB"
                  className="md:group-hover:fill-[#26231B] transition-colors duration-300"
                />
                <path
                  d="M19.338 13.56L16.09 16.822L23.314 16.822L23.314 17.97L16.09 17.97L19.338 21.232L17.658 21.232L13.934 17.396L17.658 13.56L19.338 13.56Z"
                  fill="#26231B"
                  className="md:group-hover:fill-[#E5E8DB] transition-colors duration-300"
                />
              </svg>
            </div>
            <div
              className="size-galleryButton absolute top-1/2 -right-5 md:right-4 -translate-y-1/2 cursor-pointer group"
              onClick={() => setCurrent((current + 1) % images.length)}
            >
              <svg className="w-full h-full" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="1"
                  y="1"
                  width="35"
                  height="34"
                  rx="17"
                  fill="#E5E8DB"
                  className="md:group-hover:fill-[#26231B] transition-colors duration-300"
                />
                <path
                  d="M17.662 22.44L20.91 19.178H13.686V18.03H20.91L17.662 14.768H19.342L23.066 18.604L19.342 22.44H17.662Z"
                  fill="#26231B"
                  className="md:group-hover:fill-[#E5E8DB] transition-colors duration-300"
                />
              </svg>
            </div>
          </div>
          <div className="w-full flex flex-nowrap gap-2 overflow-scroll" data-transition="children/fade-up">
            {images.map(
              (image, index) =>
                !!image?.mediaItemUrl && (
                  <div
                    key={index}
                    className={cn(
                      `gallery-thumb-${index}`,
                      "gallery-thumb h-[20vw] md:h-[6.17vw] rounded-lg overflow-hidden cursor-pointer duration-300 shrink-0",
                    )}
                    onClick={() => setCurrent(index)}
                  >
                    <ResponsiveImage
                      {...image}
                      alt={`Gallery image ${index + 1}`}
                      className={cn("w-auto h-full object-cover transition-opacity", current !== index && "opacity-50")}
                    />
                  </div>
                ),
            )}
          </div>
        </div>
      </div>
    </ScrollReveal>
  )
})
